export const borders = {
  borders: {
    md: '1px solid',
  },
  borderWidths: {
    0: '0',
    md: '1px',
  },
}
